import ReactGA from 'react-ga4';
var id = process.env.GOOGLE_TRACKING_ID;
if (id) {
    ReactGA.initialize(id);
}
